import { useEffect, useRef } from 'react'

/**
 * Resizes a textarea element to fit its content, with a maximum height.
 */
export function resizeTextarea(textarea: HTMLTextAreaElement) {
  // Reset height to auto to get the correct scrollHeight
  textarea.style.height = 'auto'

  // Calculate the new height, max 400px
  const scrollHeight = textarea.scrollHeight
  const maxHeight = 400
  const newHeight = Math.min(scrollHeight, maxHeight)

  textarea.style.height = `${newHeight}px`
  textarea.style.overflowY = 'auto'
}

/**
 * Hook that manages textarea resize behavior.
 * Returns a ref to attach to the textarea and automatically resizes it when the input value changes.
 */
export function useTextareaResize(input: string) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null)

  // Resize textarea when input changes (including when cleared)
  useEffect(() => {
    // Use setTimeout to ensure DOM is updated
    const timeoutId = setTimeout(() => {
      if (textareaRef.current) {
        resizeTextarea(textareaRef.current)
      }
    }, 0)
    return () => clearTimeout(timeoutId)
  }, [input])

  return textareaRef
}
